// @ts-nocheck
import React from "react"
import { Button as BP5Button } from "@blueprintjs/core"

export const Button = props => <BP5Button {...props} />
